import config from 'config';
import { random } from 'lodash';
import { useState } from 'react';
import { useAppDispatch } from 'reducer';
import { errorAlert, successAlert } from 'reducer/slices/alertSlice';
import { hideLoading, showLoading } from 'reducer/slices/loadingSlice';
import { hidePopup } from 'reducer/slices/popupSlice';
import gather from 'tools/gather';

const AddBalance = ({ coin, user }: any) => {
  console.log({ coin, user });
  const dispatch = useAppDispatch();
  const [password, setPassword] = useState('');
  const [amount, setAmount] = useState('');
  const [side, setSide] = useState('');
  const [comment, setComment] = useState('');
  const [memo, setMemo] = useState('');
  const [hash, setHash] = useState('');
  const [sender, setSender] = useState('');
  const [receiver, setReceiver] = useState('');

  const uniqueID = random(1000000000, 9000000000).toString();

  const submit = async () => {
    dispatch(showLoading());

    const result = await gather(`${config.apiUrl}/v1/admin/transaction`, true).post({
      password: password,
      amount: amount,
      side: side,
      coin: coin._id,
      user: user._id,
      uniqueID: uniqueID,
      comment: comment,
      hash: hash,
      memo: memo,
      sender: sender,
      receiver: receiver,
    });

    if (result.code === 200) {
      dispatch(hidePopup());
      dispatch(successAlert('Done!'));
    } else {
      dispatch(errorAlert(result.message ?? 'Not connected to server'));
    }

    dispatch(hideLoading());
  };

  return (
    <div className='login loginAuto'>
      <div className='inputLogin'>
        <span>Amount ({coin.symbol})</span>
        <input type='text' onChange={(e) => setAmount(e.target.value)} />
      </div>
      <div className='inputLogin'>
        <span>Side</span>
        <select value={side} onChange={(e) => setSide(e.target.value)}>
          <option value=''>Select</option>
          <option value='receive'>Receive (Increase - Up)</option>
          <option value='send'>Send (Decrease - Down)</option>
        </select>
      </div>
      <div className='inputLogin'>
        <span>Comment</span>
        <input type='text' onChange={(e) => setComment(e.target.value)} />
      </div>

      <div className='inputLogin'>
        <span>Hash</span>
        <input type='text' onChange={(e) => setHash(e.target.value)} />
      </div>
      <div className='inputLogin'>
        <span>Sender</span>
        <input type='text' onChange={(e) => setSender(e.target.value)} />
      </div>
      <div className='inputLogin'>
        <span>Receiver</span>
        <input type='text' onChange={(e) => setReceiver(e.target.value)} />
      </div>
      <div className='inputLogin'>
        <span>Memo</span>
        <input type='text' onChange={(e) => setMemo(e.target.value)} />
      </div>

      <div className='inputLogin'>
        <span>Password</span>
        <input type='password' onChange={(e) => setPassword(e.target.value)} />
      </div>
      <div className='submit' onClick={() => submit()}>
        Submit
      </div>
    </div>
  );
};

export default AddBalance;
